import React from 'react'

const OrderTrackingIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width={60}
            height={60}
            x={0}
            y={0}
            viewBox="0 0 512 512"
            style={{ enableBackground: "new 0 0 512 512" }}
            xmlSpace="preserve"
            className=""
        >
            <g>
                <path
                    d="M479.82 31.281c-68.558-67.594-182.547-17.926-183.918 75.352-.535 37.43 17.918 71.953 49.36 92.324 6.558 4.25 4.558 2.645 43.68 71.75.699 1.234 1.519 2.332 2.421 3.309L334.29 329c-20.71-20.562-55.094-16.75-70.789 7.992l-76.18-45.34c-.113-25.105-20.582-45.507-45.718-45.507-39.903 0-60.434 47.726-33.524 76.757l-49.844 75.313C29.191 389.906 0 411.809 0 442.188c0 25.203 20.5 45.714 45.707 45.714 43.969 0 62.473-56.355 27.133-82.48L121 332.664c23.738 12.082 53.23 1.137 63.148-24.094l73.196 43.567c-5.91 28.3 15.828 55.011 44.758 55.011 33.265 0 55.437-34.636 41.558-64.753 69.809-67.254 65.52-63.02 66.211-63.973 3.649-1.313 6.922-3.879 9.09-7.715 39.101-69.074 37.117-67.5 43.7-71.762C493.558 178.91 512 144.992 512 108.22c0-29.14-11.426-56.469-32.18-76.938zM75.273 442.187c0 16.301-13.265 29.567-29.566 29.567s-29.555-13.266-29.555-29.566c0-16.305 13.254-29.567 29.555-29.567s29.566 13.262 29.566 29.566zm42.133-133.367c-13.656-19.363.211-46.523 24.196-46.523 16.382 0 29.566 13.355 29.566 29.566 0 28.668-37.137 40.617-53.762 16.957zM302.102 391c-19.536 0-30.977-18.39-29.547-29.82.175-25.93 31.543-38.993 50.097-20.965 18.938 18.27 6.075 50.785-20.55 50.785zm152.32-204.762c-5.207 3.38-9.547 7.961-12.547 13.262-38.898 68.715-36.14 64.816-37.922 64.816-1.785 0 1.035 4.008-37.926-64.816-3-5.3-7.328-9.883-12.539-13.254-27.039-17.523-42.91-47.2-42.445-79.39 1.168-81.07 99.914-122.192 158.148-64.793 42.313 41.734 35.086 111.851-14.77 144.175zm0 0"
                    fill="#092c4c"
                    opacity={1}
                    data-original="#000000"
                    className=""
                />
                <path
                    d="M464.457 63.45c-25.375-34.384-72.617-39.872-105.16-15.852-32.68 24.117-40.93 71.18-15.856 105.16 26.668 36.137 77.598 40.418 110.18 11.808a8.074 8.074 0 0 0 .742-11.394c-2.941-3.352-8.043-3.684-11.398-.742-25.672 22.527-65.63 19.058-86.527-9.262-19.68-26.672-13.211-63.637 12.449-82.578 25.644-18.926 62.71-14.461 82.574 12.45 12.816 17.366 14.695 39.366 6.914 57.98a8.08 8.08 0 0 0 4.336 10.566c4.113 1.715 8.848-.223 10.566-4.34 9.633-23.043 7.864-51.191-8.82-73.797zm0 0"
                    fill="#092c4c"
                    opacity={1}
                    data-original="#000000"
                    className=""
                />
            </g>
        </svg>

    )
}

export default OrderTrackingIcon